import React, { useState, useEffect } from "react";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { Link } from "react-router-dom";
import { baseurl, imageUrl } from "../Baseurl";
import axios from "axios";
import noproduct from "../component/img/product_not_found.jpeg";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseurl}GetAllBlogsPublish`)
      .then((res) => {
        setBlogs(res.data.filter((blog) => blog.is_published));
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err);
      });
  }, []);

  return (
    <>
      <VisitorNavbar />

      <div className="blog-header">
        <div className="overlay">
          <h1 className="blog-header-title">Blogs</h1>
        </div>
      </div>

      <div className="container py-5">
        {/* <h2 className="text-center mb-4 fw-bold">📰 Latest Blog Posts</h2> */}
        <div className="row g-4">
          {blogs.length === 0 ? (
            <div className="text-center">
              <img src={noproduct} alt="No Blogs" style={{ width: "250px" }} />
              <p className="mt-2 text-muted">No blog posts available.</p>
            </div>
          ) : (
            blogs.map((blog) => (
              <div className="col-md-4" key={blog.id}>
                <div class="blog-card">
                  <div class="image-wrapper">
                    <img
                      src={
                        blog.thumbnail
                          ? `${imageUrl}blog/${blog.thumbnail}`
                          : noproduct
                      }
                      alt={blog.alt_img || blog.title}
                    />
                    <span class="date-badge">
                      {new Date(blog.published_at).toLocaleDateString()}
                    </span>
                  </div>
                  <div class="card-content">
                    <Link to={`/blog/${blog.slug}`} data-discover="true">
                      <h3>{blog.title}</h3>
                    </Link>
                    <Link
                      class="read-more"
                      to={`/blog/${blog.slug}`}
                      data-discover="true"
                    >
                      READ MORE <span>↗</span>
                    </Link>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Blogs;
